/**
 * Filename: axios配置
 * Created Date:2021/9/6
 * Author: pyh
 *
 * Copyright (c) 2021 Your Company
 */

import axios from 'axios';
import qs from 'qs';
import { Message } from 'element-ui';
import Router from '../router';
import Store from '../store';
import i18n from '../language';
import { noThrottle, noLoading } from './white';
import tips from '../plugins/message';
// 请求个数
let reqNum = 0;
let overtime = 100000;

// 防抖
let reqList = []; // 请求列表
// 防抖参考文档 https://blog.csdn.net/weixin_48255917/article/details/110041031
let errStrArr = [
    '用户已被注册',
    '邮箱不存在',
    '密码错误',
    '没有权限',
    '验证码错误或已过期',
    '手机号不存在',
    '用户不存在',
    '已经绑定过啦！',
];
/**
 * @author pyh
 * @description 阻止重复请求
 * @param {array} reqList - 请求缓存列表
 * @param {string} url - 当前请求地址
 * @param {function} cancel - 请求中断函数
 * @param {string} errorMessage - 请求中断时需要显示的错误信息
 * @returns 无
 */
const stopRepeatRequest = function ({ list = [], url = '', cancel, errorMessage }) {
    // const errorMsg = errorMessage || '';
    // let item = list.find(itm => itm === url); // 请求地址列表内是否有这个URL
    // if (item) {
    //     cancel(errorMsg);
    //     return
    // }
    // if (!noThrottle.includes(url) && url.indexOf('localhost') === -1) { // 白名单接口不做节流判断
    //     reqList.push(url);
    // }
};

/**
 * @author pyh
 * @description 允许某个请求可以继续进行
 * @param {string} url - 当前请求地址
 * @returns 无
 */

const allowRequest = function (url) {
    let index = reqList.findIndex(itm => itm === url);
    if (index !== -1) {
        reqList.splice(index, 1);
        return;
    }
};

// 添加请求拦截器
axios.interceptors.request.use(
    config => {
        let store = JSON.parse(localStorage.getItem('store'));
        let tokenA = '';
        if (store !== null && store.user && store.user.token) {
            tokenA =
                store.user.token.indexOf('Bearer') === -1
                    ? 'Bearer ' + store.user.token
                    : store.user.token;
        }
        config.headers.Authorization = tokenA;

        let cancel = null;
        config.cancelToken = new axios.CancelToken(function (c) {
            cancel = c;
        });
        // console.log(config.url)
        if (!noLoading.includes(config.url) && config.url.indexOf('localhost') === -1) {
            // 不需要loading的URL loading不显示
            if (!Store.state.loading) Store.commit('setLoading', true);
        }
        reqNum++;
        stopRepeatRequest({
            list: reqList,
            url: config.url,
            cancel,
            errorMessage:
                process.env.NODE_ENV === 'production'
                    ? i18n.t(`message.请勿频繁点击`)
                    : '中断请求：' + config.url,
        });
        return config;
    },
    error => Promise.reject(error) // 预处理请求错误(error)
);

/**
 * @author pyh
 * @description 错误码处理
 * @param {number} code - 错误码
 * @returns 无
 */
let handleError = ({ code, errorMsg = '' }) => {
    // console.log(code, errorMsg);
    let toLogin = () => {
        setTimeout(() => {
            Router.push({
                name: 'login',
            });
        });
    };
    if (errStrArr.includes(errorMsg)) {
        Message({
            type: '',
            dangerouslyUseHTMLString: true,
            center: true,
            message: tips.error(i18n.t(`error.${errorMsg}`)),
        });
    } else if (code) {
        let msg = code;
        if (process.env.VUE_APP_AUDIENCE === 'CLOUD' && errorMsg.includes('PasswordEncoder')) {
            // 云平台-该账号暂未设置密码时
            msg = '该账号暂未设置密码';
        }
        Message({
            type: '',
            dangerouslyUseHTMLString: true,
            center: true,
            message: tips.error(i18n.t(`message.${msg}`)),
        });
    } else {
        Message({
            type: '',
            dangerouslyUseHTMLString: true,
            center: true,
            message: tips.error(i18n.t(`message.其他错误`)),
        });
    }
    switch (code) {
        case 401:
            if (errorMsg === '没有权限') toLogin();
            break;
        case 403:
            toLogin();
            break;
    }
};

/**
 * @author pyh
 * @description 请求个数处理
 * @returns 无
 */

let handerRes = url => {
    reqNum--;
    if (reqNum <= 0) {
        Store.commit('setLoading', false);
    } else {
        if (!noLoading.includes(url) && url.indexOf('localhost') === -1) {
            Store.commit('setLoading', true);
        }
    }
};

// 添加响应拦截器
axios.interceptors.response.use(
    response => {
        // 预处理响应数据（response）如果数据当中有不要的部分，就截留
        if (response.config.handleTipsBySelf) {
            return response.data.data;
        }
        setTimeout(() => {
            allowRequest(response.config.url); // 增加延迟相同请求不得在短时间内重复发送
        }, 500);
        handerRes(response.config.url);
        // console.log(response);
        if (response.data.code === 200) {
            return response.data.data;
        } else {
            // 错误码处理
            handleError({
                code: response.data.code,
                errorMsg: response.data.message,
            });
            return Promise.reject(response.data);
        }
    },
    error => {
        let response = error.response;
        // console.log(response);
        console.log(error);
        console.log('error url:', error.config.url); // 预处理响应错误（error)
        handerRes(error.config.url); // 处理请求个数
        if (axios.isCancel(error)) {
            console.log(error.message, 'isCancel');
        } else {
            setTimeout(() => {
                allowRequest(error.config.url); // 增加延迟相同请求不得在短时间内重复发送
            }, 1000);
        }
        handleError({
            code: response ? response.status : '',
            errorMsg: response ? response.data.message : '',
        });
        return Promise.reject(error);
    }
);

export default function (
    url,
    {
        method = 'get',
        timeout = overtime,
        data = {},
        params = {},
        cancelToken = '',
        handleTipsBySelf = false,
        axiosBaseUrl = '',
        headers = {
            'Content-Type': 'application/json', // json请求头
        },
        responseType = 'json',
    }
) {
    const config = {
        method: method,
        timeout,
        url: url, // 如果URL是完整的，包含域名，则下方的域名不会被拼接
        baseUrl: axiosBaseUrl, // 接口前缀url，默认为空，为空的情况```axios.defaults.baseURL = baseCof.URL_CNODEJS;```会生效
        data: data,
        params: params,
        handleTipsBySelf, // 是否自己处理返回值，可能会根据后台返回不用的code做不同的处理。使用查看./server.js login_email方法
        cancelToken: cancelToken, // 关闭请求
        headers: headers,
        responseType: responseType,
    };

    if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        config.data = qs.stringify(config.data);
    }
    return axios(config);
}
